import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Normal from "./Normal";
import Feilmelding from "./Feilmelding";
export const _frontmatter = {
  "ingress": "Denne komponenten bør brukes hvis det er nødvendig å innhente samtykke fra brukeren før de går videre i prosessen. Komponenten skal gi brukeren tydelig beskjed om hvorfor de må samtykke og hva de samtykker til."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Normal mdxType="Normal" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<BekreftCheckboksPanel
  label="Ja, jeg samtykker"
  checked={isChecked}
  onChange={(e) => setIsChecked(e.target.checked)}
>
  For å komme videre må du gi oss lov til å hente inn og bruke opplysninger om
  deg.{" "}
  <Lenke href="#">
    Les om hvilke opplysninger vi henter og hvordan vi bruker dem.
  </Lenke>
</BekreftCheckboksPanel>
`}</code></pre>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <Feilmelding mdxType="Feilmelding" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<BekreftCheckboksPanel
  label="Jeg bekrefter at opplysningene jeg har gitt, er riktige og fullstendige"
  checked={isChecked}
  onChange={(e) => setIsChecked(e.target.checked)}
  feil="Du må bekrefte dette før du kan sende inn søknaden."
>
  Jeg vet at jeg kan miste retten til sykepenger hvis opplysningene jeg gir,
  ikke er riktige eller fullstendige.
</BekreftCheckboksPanel>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      